import React from "react";
import { ResponsivePie } from "@nivo/pie";
import {
  createStyles,
  Theme,
  WithStyles,
  withStyles,
} from "@material-ui/core/styles";

interface Props extends WithStyles<typeof styles> {
  referred: any;
  screened: any;
  positiveCases: any;
  recovered: any;
  death: any;
}
const styles = (theme: Theme) =>
  createStyles({
    root: {
      height: 300,
    },
  });
class PieChartComponent extends React.Component<Props> {
  render() {
    const { recovered, positiveCases, death } = this.props;
    let total = recovered + positiveCases + death;
    let positivePec = Math.round((positiveCases / total) * 100);
    let recoveredPec = Math.round((recovered / total) * 100);
    let deathPec = Math.round((death / total) * 100);
    return (
      <div style={{ width: "100%", height: 500 }}>
        <ResponsivePie
          data={[
            {
              id: "Positive Cases",
              label: "Positive Cases",
              item: positivePec + "%",
              value: positiveCases,
              color: "hsl(346, 70%, 50%)",
            },
            {
              id: "Recovered",
              label: "Recovered",
              item: recoveredPec + "%",
              value: recovered,
              color: "hsl(24, 100%, 50%)",
            },
            {
              id: "deaths",
              label: "Deaths",
              item: deathPec + "%",
              value: death,
              color: "hsl(24, 70%, 50%)",
            },
          ]}
          margin={{ top: 60, right: 60, bottom: 60, left: 60 }}
          colors={[
            "hsl(209, 100%, 50%)",
            "hsl(37, 100%, 66%)",
            "hsl(0, 100%, 50%)",
          ]}
          borderWidth={3}
          borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
          radialLabelsSkipAngle={15}
          radialLabelsTextXOffset={6}
          radialLabelsTextColor="#333333"
          radialLabelsLinkOffset={6}
          radialLabelsLinkDiagonalLength={14}
          radialLabelsLinkHorizontalLength={12}
          radialLabelsLinkStrokeWidth={3}
          slicesLabelsTextColor="#FFFFFF"
          radialLabelsLinkColor={{ from: "color" }}
          sliceLabel={function (e) {
            return e.item + " ";
          }}
          slicesLabelsSkipAngle={2}
          animate={true}
          motionStiffness={90}
          motionDamping={15}
          defs={[
            {
              id: "dots",
              type: "patternSquares",
              background: "inherit",
              color: "hsl(209, 100%, 50%)",
              size: 4,
              padding: 1,
              stagger: true,
            },
          ]}
          fill={[
            {
              match: {
                id: "ruby",
              },
              id: "dots",
            },
            {
              match: {
                id: "c",
              },
              id: "dots",
            },
          ]}
          legends={[
            {
              anchor: "bottom",
              direction: "row",
              translateY: 56,
              itemWidth: 100,
              itemHeight: 18,
              itemsSpacing: 10,
              itemTextColor: "#000000",
              symbolSize: 18,
              symbolShape: "square",
              effects: [
                {
                  on: "hover",
                  style: {
                    itemTextColor: "#000",
                  },
                },
              ],
            },
          ]}
        />
      </div>
    );
  }
}
export default withStyles(styles)(PieChartComponent);
